import { render, staticRenderFns } from "./CorporationInfo2.vue?vue&type=template&id=3433b89c"
import script from "./CorporationInfo2.vue?vue&type=script&lang=js"
export * from "./CorporationInfo2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3433b89c')) {
      api.createRecord('3433b89c', component.options)
    } else {
      api.reload('3433b89c', component.options)
    }
    module.hot.accept("./CorporationInfo2.vue?vue&type=template&id=3433b89c", function () {
      api.rerender('3433b89c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/admin/CorporationInfo2.vue"
export default component.exports